import { useState } from "react";
import PaymentService from "../../services/paymentService";
import acbLogo from "../../assets/images/acb/acb.webp";
import c from "./styles.module.scss";

const CartAlatauButton = ({ orderNumber, onSuccess }) => {
  const [isLoading, setIsLoading] = useState(false);

  const payWithAlatau = async () => {
    try {
      if (!orderNumber) {
        alert("Order id not found");
        return;
      }

      setIsLoading(true);
      const html = await PaymentService.createAlatauPayment(orderNumber);

      PaymentService.redirectToAlatau(html);

      if (onSuccess) {
        await onSuccess();
      }
    } catch (err) {
      console.error("ALATAU PAY ERROR:", err);
      alert("Ошибка при создании платежа");
      setIsLoading(false);
    }
  };

  return (
    <button
      type="button"
      className={c.alatau}
      onClick={payWithAlatau}
      disabled={isLoading}
    >
      <span className={c.alatauContent}>
        <img src={acbLogo} alt="Alatau City Bank" width="120" height="30" />
        <span>Оплатить картой</span>
      </span>
    </button>
  );
};

export default CartAlatauButton;
